export const EARLIEST_PROJECT_DATE = "01/01/2015";
export const MILESTONES = {
  NEW: "New",
  QUALIFIED: "Qualified",
  PROPOSAL_REQUESTED: "Proposal Requested",
  PROPOSAL_GENERATED: "Proposal Generated",
  PROPOSAL_PRESENTED: "Proposal Presented",
  DOCUMENTS_OUT: "Documents Out",
  SALE_COMPLETE: "Sale Complete",
  CONTRACT_SIGNED: "Contract Signed",
  PROJECT_INTAKE: "Project Intake",
  PROJECT_START: "Project Start",
  SITE_SURVEY_SCHEDULED: "Site Survey Scheduled",
  SITE_SURVEY_COMPLETED: "Site Survey Completed",
  PROJECT_CONFIRMATION: "Project Confirmation",
  DESIGN_COMPLETED: "Design Completed",
  PERMIT_SUBMISSION: "Permit Submission",
  PERMIT_APPROVED: "Permit Approved",
  INSTALLATION_SCHEDULED: "Installation Scheduled",
  SUBMIT_INSTALLATION_COMPLETE: "Submitted Installation Complete",
  PERMISSION_TO_OPERATE: "Permission to Operate",
  PTO: "PTO",
};

export const STAGES = {
  QUALIFIED: "Qualified",
  PROPOSAL_REQUESTED: "Proposal Creation",
  PROPOSAL_PRESENTED: "Proposal Presentation",
  DOCUMENTS_OUT: "Documents Out",
  CONTRACT_SIGNED: "Contract Signed",
  SITE_SURVEY: "Site Survey",
  PROJECT_CONFIRMATION: "Project Confirmation",
  DESIGN: "Design",
  PERMITTING: "Permitting",
  INSTALLATION: "Installation",
  INSPECTION: "Inspection",
  PTO: "PTO",
  POWUR_ON: "Powur On!",
};

export const ACTIVITIES = {
  PTO_APPLICATION_SUBMITTED: "PTO Application Submitted",
};

export const CERTIFICATION_TIER = {
  SETTER: 1,
  SALES_PRO: 2,
  CLOSER: 3,
};

export const SERVICE_SLUGS = {
  POWUR_CLOSER: "powur_closer",
  POWUR_ENTERPRISE: "powur_enterprise",
  POWUR_ENERGY: "powur_energy",
  POWUR_ENTERPRISE_PRO: "powur_enterprise_pro",
};
